import { Badge } from '@atoms/badges/Badge/Badge';

type WebhookStatusBadgeProps = {
  active: boolean;
};

export const WebhookStatusBadge = ({ active }: WebhookStatusBadgeProps) => (
  <Badge
    label={active ? 'Active' : 'Inactive'}
    className={active ? 'bg-status-completed' : 'bg-status-neutral'}
  />
);
